const late_train = `Asunto: Queja por retraso de tren
A quien le interese,
Le escribo para expresar mi profunda frustración por el importante retraso de mi reciente viaje en tren con realidad virtual.
El tren que tomé el [fecha] llegó a mi destino con 45 minutos de retraso,
haciéndome llegar tarde a una reunión crucial.
Este retraso tuvo un impacto considerable en mis compromisos profesionales,
lo que resulta en oportunidades perdidas y posibles consecuencias financieras.
Además, causó estrés e inconvenientes innecesarios,
interrumpiendo mi agenda cuidadosamente planeada para el día.
Ante esta situación,
Insto a VR a que adopte medidas inmediatas para mejorar la puntualidad de los servicios ferroviarios y garantizar que no se produzcan retrasos tan importantes en el futuro.
Implementar mejores prácticas de mantenimiento y adherirse a protocolos de programación más eficientes podría ayudar a mitigar la frecuencia de dichas interrupciones y mantener la confiabilidad de sus servicios.
Agradezco su pronta atención a este asunto y confío en que se tomarán las medidas necesarias para evitar que incidentes similares se repitan.
Sinceramente, `;
export default late_train;